import React from 'react'
import TDSDialog from '~shared/lib/TDSDialog/TDSDialog'
import { Order } from '../../../Types/Order'
import styles from './PaymentErrorDialog.module.scss'
import { CircleCrossIcon } from '../../../Assets/svg/Icons'
import { Alert } from '@instacart/tds'

type PaymentErrorDialogProps = {
  order: Order
  paymentError: string
  onDialogClose: () => void
}

export const PaymentErrorDialog = ({
  order,
  paymentError,
  onDialogClose,
}: PaymentErrorDialogProps) => {
  return (
    <TDSDialog
      toggleDialog={onDialogClose}
      action={onDialogClose}
      header={''}
      actionButtonLabel="Close"
      showCloseIcon={false}
    >
      <div className={styles.paymentErrorDialog}>
        <div className={styles.errorIcon}>
          <CircleCrossIcon />
        </div>
        <h3>Payment Failed for Order {order.orderNo}</h3>
        <p>Error: {paymentError}</p>
        <div className={styles.paymentErrorAlert}>
          <Alert layout="horizontal" isDismissible={false} variant="warning">
            <span>Please direct the customer to pay at the register.</span>
          </Alert>
        </div>
      </div>
    </TDSDialog>
  )
}
